import { render, staticRenderFns } from "./gameItemConfig.vue?vue&type=template&id=f0a54322&"
import script from "./gameItemConfig.vue?vue&type=script&lang=js&"
export * from "./gameItemConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/www/game/xcp-vue-xc01/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f0a54322')) {
      api.createRecord('f0a54322', component.options)
    } else {
      api.reload('f0a54322', component.options)
    }
    module.hot.accept("./gameItemConfig.vue?vue&type=template&id=f0a54322&", function () {
      api.rerender('f0a54322', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/xcpGameManager/gameItemConfig.vue"
export default component.exports